import React, { useState } from 'react';
import { FaSmile, FaMicrophone,FaPaperPlane, FaPaperclip } from "react-icons/fa";

const ChatInput = ({ onSendMessage }) => {
  const [text, setText] = useState("");

  const handleSend = () => {
    if (text.trim() !== "") {
      onSendMessage(text);
      setText("");
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') handleSend();
  };

  return (
    <div className="chat-footer">
      {/* <FaSmile size={24} color="#54656f" style={{cursor:'pointer'}}/> */}
      {/* <FaPaperclip size={20} color="#54656f" style={{cursor:'pointer'}}/> */}
      
      <div className="input-box">
        <input 
          type="text" 
          placeholder="Type a message" 
          value={text}
          onChange={(e) => setText(e.target.value)}
          onKeyDown={handleKeyPress}
        />
      </div>
      
      <FaPaperPlane size={20} color="#54656f" style={{cursor:'pointer'}} onClick={handleSend} />
      {/* <FaMicrophone size={20} color="#54656f" style={{cursor:'pointer'}} onClick={handleSend} /> */}
    </div>
  );
};

export default ChatInput;